<template>
  <footer class="footer">
    <div class="footer__wapper">
      <div class="footer__section">
        <div class="footer__section__item">
          <h3 class="font--display-2">{{ $t("footer.jaiJinendra") }}</h3>
          <p class="decription">{{ $t("footer.message") }}</p>
          <ul class="footer-social-icons">
            <li v-for="(icon, index) in socialLinks" :key="index">
              <a :href="icon.link" :title="icon.title" target="_blank" rel="noopener">
                <i aria-hidden="true" class="icon" :class="`icon-${icon.icon}`"></i>
              </a>
            </li>
          </ul>
        </div>
        <div class="footer__section__item nav-link">
          <h3 class="font--display-1">{{ $t("footer.usefulLinks") }}</h3>
          <ul class="footer-nav">
            <li v-for="(menu, index) in menus" :key="index">
              <router-link :to="menu.link" :router-link="menu.link" rel="noopener">
                {{ $t(menu.item) }}
              </router-link>
            </li>
          </ul>
        </div>
        <div class="footer__section__item">
          <h3 class="font--display-1">{{ $t("footer.latestNews") }}</h3>
          <NewsFeed :limit="true"></NewsFeed>
        </div>
      </div>
      <p class="text--center">{{ $t("copyright") }} &copy; {{ currentYear }}, {{ $t("copyright.text") }}</p>
    </div>
  </footer>
</template>

<script>
import { constants } from "@/lib/constants";
import NewsFeed from "@/components/common/NewsFeed";

export default {
  name: "Footer",
  data() {
    return {
      currentYear: "",
      menus: constants.menus,
      socialLinks: constants.socialLinks
    };
  },
  components: {
    NewsFeed
  },
  created() {
    this.currentYear = new Date().getFullYear();
  }
};
</script>
